
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderBrandAmbassadorShareDialog extends Serenity.EntityDialog<OrderBrandAmbassadorShareRow, any> {
        protected getFormKey() { return OrderBrandAmbassadorShareForm.formKey; }
        protected getIdProperty() { return OrderBrandAmbassadorShareRow.idProperty; }
        protected getLocalTextPrefix() { return OrderBrandAmbassadorShareRow.localTextPrefix; }
        protected getService() { return OrderBrandAmbassadorShareService.baseUrl; }
        protected getDeletePermission() { return OrderBrandAmbassadorShareRow.deletePermission; }
        protected getInsertPermission() { return OrderBrandAmbassadorShareRow.insertPermission; }
        protected getUpdatePermission() { return OrderBrandAmbassadorShareRow.updatePermission; }

        protected form = new OrderBrandAmbassadorShareForm(this.idPrefix);

    }
}